import { useMutation } from "@tanstack/react-query";
import { apiChangePass } from "./service";

export const useChangePassword = () => {
  return useMutation({
    mutationFn: ({ params }: { params: ChangePasswordParams }) =>
      apiChangePass(params),
  });
};
